import axios from 'axios';
import { useEffect, useRef } from 'react';

import { getInjector, getRootScope } from '@/services/angularjs-bridge';

const ItemReviewTab = ({ primaryKey, onReviewChange, onToggleReview }: { primaryKey: string; onReviewChange?: (isDirty: boolean) => void; onToggleReview?: () => void }) => {

    const ref = useRef<HTMLDivElement>(null);

    const $angularJsInjector = getInjector();
    const $rootScope = getRootScope($angularJsInjector);
    const $controller = $angularJsInjector.get('$controller');
    const $compile = $angularJsInjector.get('$compile');
    const $templateCache = $angularJsInjector.get('$templateCache');

    useEffect(() => {

        (async function() {

            if (!ref || !ref.current) {
                return;
            }

            // Prepare a new scope for the review item tab
            const $scope = $rootScope.$new();
            $scope.item = {
                primaryKey__: primaryKey,
            };

            // Add toggleItemReview callback to scope so AngularJS controller can call it
            if (onToggleReview) {
                $scope.toggleItemReview = onToggleReview;
            }

            // Prepare the review item tab template
            const templateUrl = 'tpl/editor/item-review-tab.tpl.html';
            let $template = $templateCache.get(templateUrl);
            if (!$template) {
                $template = (await axios.get(templateUrl)).data;
                // Let's cache the template for further use in the current session
                $templateCache.put(templateUrl, $template);
            }

            // Prepare the controller
            $controller('ItemReviewController', {
                $scope: $scope,
                $element: ref.current,
            });

            if (onReviewChange) {
                $scope.$on('reviewChanged', () => {
                    onReviewChange(true);
                });
            }

            // Compile the template and attach the $scope to it
            const compileResult = $compile($template)($scope);
            //@ts-ignore
            angular.element(ref.current).append(compileResult);

            $rootScope.$evalAsync();

        })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    return (
        <div className='tw-absolute tw-bottom-[60px] tw-bg-[#f6f6f6] tw-w-full tw-z-50 tw-px-4 tw-pt-2 tw-pb-6 tw-max-h-[70vh] tw-overflow-y-auto'>
            <div className="tw-h-full tw-flex-1 tw-flex tw-flex-col" ref={ref}></div>
        </div>
    );
};

export { ItemReviewTab };
